var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ctk-list-header',{staticClass:"invoices-header",attrs:{"title":_vm.title,"subtitle":_vm.subtitle}},[_c('ui-button',{staticClass:"invoices-header__actions",attrs:{"to":{
      name: 'AccountBilling'
    },"rounded":false,"variant":"info"}},[_vm._v(" "+_vm._s(_vm.$t('billing.buttons.settings'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }